import { useState, useEffect, useContext } from 'react';
import {
    Modal, ModalDialog, Typography, Button, Box, Stack, Select, Option, Input,
    ModalClose,
} from '@mui/joy';
import { AppContext } from '../../context';
import { APIGetEmployees, APIManagerEditSchedule, parseApiError } from '../../api';
import TimeSelect5 from '../../components/TimeSelect5';


const fmtDateRu = (iso) => {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('ru-RU', {
        weekday: 'short', day: 'numeric', month: 'short',
    });
};


export default function ManagerScheduleEditModal({ open, date, onClose, onSaved }) {
    const { token, showToast } = useContext(AppContext);

    const [photographers, setPhotographers] = useState([]);
    const [accountId, setAccountId] = useState(null);
    const [time, setTime] = useState('10:00');
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (!open || !token) return;
        (async () => {
            const list = await APIGetEmployees(token);   // все сотрудники
            const schedulable = (Array.isArray(list) ? list : [])
                .filter(e => ['photographer', 'admin', 'admin_photographer'].includes(e.role));
            setPhotographers(schedulable);
        })();
    }, [open, token]);

    const submit = async (action) => {
        if (!accountId) {
            showToast('Выбери сотрудника', 'warning');
            return;
        }
        setBusy(true);
        const res = await APIManagerEditSchedule(token, {
            account_id: accountId,
            date,
            action,
            preferred_time: action === 'add' ? time : undefined,
        });
        setBusy(false);
        if (res?.error) {
            showToast(parseApiError(res.error, 'Не удалось изменить график'), 'danger');
            return;
        }
        showToast(action === 'add' ? 'День добавлен в график' : 'День убран из графика');
        onSaved?.();
        onClose?.();
    };

    return (
        <Modal open={open} onClose={() => !busy && onClose?.()}>
            <ModalDialog sx={{
                bgcolor: 'var(--joy-palette-background-level1)',
                border: '1px solid var(--joy-palette-divider)',
                borderRadius: 'var(--joy-radius-xl)',
                maxWidth: 400, width: '100%',
                p: { xs: 2, sm: 3 },
                maxHeight: '95vh', overflowY: 'auto',
            }}>
                <ModalClose />

                <Typography level="h4" sx={{ fontWeight: 800, mb: 0.5 }}>
                    Изменить график
                </Typography>
                <Typography sx={{ fontSize: 12, color: 'var(--joy-palette-text-tertiary)', mb: 2 }}>
                    Дата: {fmtDateRu(date)}
                </Typography>

                <Stack spacing={1.5}>
                    <Box>
                        <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 0.6 }}>Сотрудник</Typography>
                        <Select
                            placeholder="Выбери сотрудника"
                            value={accountId}
                            onChange={(_, v) => setAccountId(v)}
                        >
                            {photographers.map(p => (
                                <Option key={p.id} value={p.id}>
                                    {p.full_name || `${p.first_name} ${p.last_name}`}
                                    {p.role === 'admin' ? (
                                        <span style={{ color: '#3b82f6', fontWeight: 700 }}> · Админ</span>
                                    ) : p.role === 'admin_photographer' ? (
                                        <span style={{ color: '#06b6d4', fontWeight: 700 }}> · Админ+Фото</span>
                                    ) : null}
                                </Option>
                            ))}
                        </Select>
                    </Box>

                    <Box>
                        <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 0.6 }}>
                            Время (для «добавить»)
                        </Typography>
                        <TimeSelect5
                            value={time}
                            onChange={(v) => setTime(v)}
                        />
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                        <Button
                            color="success" variant="solid" sx={{ flex: 1 }}
                            loading={busy} onClick={() => submit('add')}
                        >
                            Добавить в график
                        </Button>
                        <Button
                            color="danger" variant="outlined"
                            loading={busy} onClick={() => submit('remove')}
                        >
                            Убрать
                        </Button>
                    </Box>
                </Stack>
            </ModalDialog>
        </Modal>
    );
}